import React from "react";
import { Link } from "react-router-dom";

export default function Strip({ isOpen, onClose }) {
  return (
    <nav className="strip__menu">
      <div className="strip__menu-inner">
        <div className="strip__dropdown">
          <Link to="/about" className="strip__item">
            Об институте
          </Link>
          <div className="strip__dropdown-content">
            <Link to="/about/history" className="strip__content">
              История института
            </Link>
            <Link to="/about/structure" className="strip__content">
              Структура института
            </Link>
            <Link to="/about/managers" className="strip__content">
              Руководители
            </Link>
            <Link to="/about/licenses" className="strip__content">
              Правовая информация и лицензии
            </Link>
            <Link to="/about/privacy" className="strip__content">
              Политика конфиденциальности
            </Link>
            <Link to="/about/anti-corruption" className="strip__content">
              Противодействие коррупции
            </Link>
            <Link to="/about/anti-terror" className="strip__content">
              Антитеррористическая безопасность
            </Link>
            <Link to="/about/controls" className="strip__content">
              Органы управления
            </Link>
            <Link to="/about/vacancies" className="strip__content">
              Вакансии
            </Link>
            <Link to="/about/news" className="strip__content">
              Новости
            </Link>
            <Link to="/about/sitemap" className="strip__content">
              Карта сайта
            </Link>
            <Link to="/about/working-conditions" className="strip__content">
              Условия труда
            </Link>
            <Link to="/about/accounting-policy" className="strip__content">
              Учетная политика
            </Link>
            <Link to="/about/independent-assessment" className="strip__content">
              Независимая оценка качества
            </Link>
            <Link to="/about/heating-season" className="strip__content">
              Подготовка к отопительному сезону
            </Link>
          </div>
        </div>
        <div className="strip__dropdown">
          <Link to="/science" className="strip__item">
            Наука
          </Link>
          <div className="strip__dropdown-content">
            <Link to="/science/research" className="strip__content">
              Научно-исследовательские разработки
            </Link>
            <Link to="/science/development" className="strip__content">
              Разработка медицинских и организационных технологий
            </Link>
            <Link to="/science/dissertation" className="strip__content">
              Диссертационный совет
            </Link>
            <Link to="/science/clinical-trials" className="strip__content">
              Клинические испытания лекарственных средств
            </Link>
            <Link to="/science/publications" className="strip__content">
              Научные публикации
            </Link>
            <Link to="/science/scientific-research" className="strip__content">
              Научные исследования
            </Link>
            <Link to="/science/certification" className="strip__content">
              Аттестация научных работников
            </Link>
            {/* <Link to="/science/assistance" className="strip__content">
              Лечебно-диагностическая помощь
            </Link> */}
          </div>
        </div>
        <div className="strip__dropdown">
          <Link to="/education" className="strip__item">
            Образование
          </Link>
          <div className="strip__dropdown-content">
            <Link to="/education/residency" className="strip__content">
              Ординатура
            </Link>
            <Link
              to="/education/postgraduate-studies"
              className="strip__content"
            >
              Аспирантура
            </Link>
            <Link to="/education/additional" className="strip__content">
              Дополнительное профессиональное образование
            </Link>
            <Link to="/education/teaching-staff" className="strip__content">
              Профессорско-преподавательский состав
            </Link>
            <Link
              to="/education/admissions-committee"
              className="strip__content"
            >
              Приемная комиссия
            </Link>
            <Link to="/education/tax-deduction" className="strip__content">
              Налоговый вычет за платные образовательные услуги
            </Link>
          </div>
        </div>
        <div className="strip__dropdown">
          <Link to="/clinic" className="strip__item">
            Клиника
          </Link>
          <div className="strip__dropdown-content">
            <Link to="/clinic/hospital" className="strip__content">
              Высокотехнологичная медицинская помощь
            </Link>
            <Link to="/clinic/specialized-medical" className="strip__content">
              Специализированная медицинская помощь
            </Link>
            {/* <Link to="/clinic/day-hospital" className="strip__content">
              Дневной стационар
            </Link> */}
            {/* <Link to="/clinic/consultative" className="strip__content">
              Консультативно-диагностическое отделение
            </Link> */}
            {/* <Link to="/clinic/laboratory" className="strip__content">
              Лаборатория
            </Link> */}
            <Link to="/clinic/working-chief" className="strip__content">
              Работа с главными врачами кожно-венерологических учреждений
            </Link>
            <Link to="/clinic/problem-syphilis" className="strip__content">
              Консультативный совет по проблемме сифилис
            </Link>
          </div>
        </div>
        <div className="strip__dropdown">
          <Link to="/patients" className="strip__item">
            Пациентам
          </Link>
          <div className="strip__dropdown-content">
            <Link to="/patients/reception" className="strip__content">
              Прием специалистов
            </Link>
            <Link to="/patients/reception-omc" className="strip__content">
              Прием специалистов ОМС
            </Link>
            <Link to="/patients/working" className="strip__content">
              График работы
            </Link>
            {/* <Link to="/services" className="strip__content">
              Услуги
            </Link> */}
            <Link to="/patients/pay" className="strip__content">
              Платные медицинские услуги
            </Link>
            <Link to="/patients/price-list" className="strip__content">
              Прейскурант
            </Link>
            <Link to="/patients/specialists" className="strip__content">
              Специалисты
            </Link>
            <Link to="/#record" className="strip__content">
              Запись на прием
            </Link>
            <Link to="/patients/provision" className="strip__content">
              Оказание услуг гражданам в сфере здравоохранения
            </Link>
            <Link to="/patients/participantsSVO" className="strip__content">
              Участникам СВО
            </Link>
            <Link
              to="/patients/accessible-environment"
              className="strip__content"
            >
              Доступная среда
            </Link>
            <Link to="/patients/helplines" className="strip__content">
              Телефоны доверия
            </Link>
            <Link to="/patients/fire-safety" className="strip__content">
              Пожарная безопасность
            </Link>
            <Link
              to="/patients/clinical-examination"
              className="strip__content"
            >
              Диспансеризация населения
            </Link>
            <Link to="/patients/week" className="strip__content">
              Мероприятия по профилактике заболеваний и поддержке здорового
              образа жизни
            </Link>
            <Link to="/patients/gosuslugi" className="strip__content">
              Госуслуги
            </Link>
            <Link to="/patients/question-answer" className="strip__content">
              Вопрос–ответ
            </Link>
            <Link to="/patients/reviews" className="strip__content">
              Отзывы
            </Link>
            <Link to="/patients/emergency-numbers" className="strip__content">
              Телефоны справочных служб
            </Link>
            {/* <Link to="/cabinet" className="strip__content">
              Личный кабинет
            </Link> */}
          </div>
        </div>

        <div className="strip__dropdown">
          <Link to="/contacts" className="strip__item">
            Контакты
          </Link>
        </div>
      </div>
    </nav>
  );
}
